module.exports = __webpack_public_path__ + "img/RECUADRO_Aprendizaje_XS.dc557d25.png";